<div>
    <div>
        <button type="button" (click)="toggleProfile()"
            class="transition-all duration-200 flex text-sm border_customize_card border-2 card_color rounded-full"
            id="user-menu-button-2">
            <span class="sr-only">Open user menu</span>
            <img class="w-9 h-9 rounded-full"
                [src]="profilePicture" alt="user photo" />
        </button>
    </div>
    <app-profile-menu [showProfileMenu]="showProfileMenu" [isPCPlayer]="isPCPlayer"
        (toggle)="toggleProfile()"></app-profile-menu>
</div>